'use client';

import Image from 'next/image';
import { CHATGPT_PLUGIN_URL } from '@/lib/chatgpt';
import { Language } from '@/lib/translations';
import { ctaClick } from '@/lib/analytics';

export default function ChatGPTBadge({
  language,
  location = 'hero',
}: {
  language: Language;
  /** Page section reported with cta_click. */
  location?: string;
}) {
  return (
    <a
      href={CHATGPT_PLUGIN_URL}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() =>
        ctaClick('chatgpt_badge', location, language, CHATGPT_PLUGIN_URL)
      }
      className="inline-flex shrink-0 rounded-md transition-transform hover:scale-105 focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-blue-500"
    >
      <Image
        src={`/assets/icons/custom/connect-on-chatgpt${language === 'zh' ? '-zh-tw' : ''}.svg`}
        alt={language === 'en' ? 'Connect on ChatGPT' : '連結至 ChatGPT'}
        width={135}
        height={40}
        className="h-10 w-auto"
      />
    </a>
  );
}
